var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label-merge',{staticClass:"mt-6 ml-6",attrs:{"page":_vm.page,"items-per-page":_vm.itemsPerPage,"search":_vm.search}}),_c('fix-case-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }